import Modal from '../ui/Modal';
import { useState, useRef } from 'react';
import { INSTRUMENTS, GENRES, LEVEL_LABELS } from '../constants';
import { migrateInstrument, migrateInstruments } from '../helpers';
import { uploadAvatarImage } from '../lib/supabase';

const CROP = 220;

function ProfileEditModal({ musician, onClose, onSave, title="Modifica profilo" }) {
  const [firstName,setFirstName]=useState(musician.first_name||''); const [lastName,setLastName]=useState(musician.last_name||''); const [email,setEmail]=useState(musician.email);
  const [city,setCity]=useState(musician.city||"");
  const [instruments,setInstruments]=useState(migrateInstruments(musician.instruments||[])); const [sings,setSings]=useState(musician.sings||false);
  const [genres,setGenres]=useState(musician.genres||[]);
  const [levels,setLevels]=useState(musician.levels||{});
  const [defaultInstrument,setDefaultInstrument]=useState(musician.default_instrument?migrateInstrument(musician.default_instrument)||"":"");
  const [defaultSings,setDefaultSings]=useState(musician.default_sings||false);
  const [phone,setPhone]=useState(musician.phone||""); const [whatsapp,setWhatsapp]=useState(musician.whatsapp_link||"");
  const [avatarPreview,setAvatarPreview]=useState(musician.avatar_url||null);
  const [avatarBlob,setAvatarBlob]=useState(null);
  // Crop editor
  const [rawImage,setRawImage]=useState(null);
  const [rawUrl,setRawUrl]=useState(null);
  const [zoom,setZoom]=useState(1);
  const [offset,setOffset]=useState({x:0,y:0});
  const [dragStart,setDragStart]=useState(null);
  const [loading,setLoading]=useState(false); const [error,setError]=useState("");
  const fileRef=useRef();

  const toggle=(arr,setArr,val)=>setArr(arr.includes(val)?arr.filter(v=>v!==val):[...arr,val]);
  const allRoles=[...(sings?["Voce"]:[]),...instruments];
  const setLevel=(role,lv)=>setLevels(prev=>({...prev,[role]:lv}));

  // Dimensioni immagine visualizzata nel crop circle
  const fitScale = rawImage ? CROP / Math.min(rawImage.naturalWidth, rawImage.naturalHeight) : 1;
  const dispW = rawImage ? rawImage.naturalWidth * fitScale * zoom : 0;
  const dispH = rawImage ? rawImage.naturalHeight * fitScale * zoom : 0;

  const clampOff = (ox, oy, dw, dh) => ({
    x: Math.max((CROP-dw)/2, Math.min((dw-CROP)/2, ox)),
    y: Math.max((CROP-dh)/2, Math.min((dh-CROP)/2, oy)),
  });

  const handleFileChange = e => {
    const file = e.target.files[0]; if(!file) return;
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { setRawImage(img); setRawUrl(url); setZoom(1); setOffset({x:0,y:0}); };
    img.src = url;
  };

  const onZoom = val => {
    const z = parseFloat(val);
    const dw = rawImage ? rawImage.naturalWidth  * fitScale * z : 0;
    const dh = rawImage ? rawImage.naturalHeight * fitScale * z : 0;
    setZoom(z);
    setOffset(prev => clampOff(prev.x, prev.y, dw, dh));
  };

  const onPointerDown = e => {
    e.currentTarget.setPointerCapture(e.pointerId);
    setDragStart({x:e.clientX, y:e.clientY, ox:offset.x, oy:offset.y});
  };
  const onPointerMove = e => {
    if(!dragStart) return;
    const dx = e.clientX - dragStart.x;
    const dy = e.clientY - dragStart.y;
    setOffset(clampOff(dragStart.ox+dx, dragStart.oy+dy, dispW, dispH));
  };
  const onPointerUp = () => setDragStart(null);

  const confirmCrop = () => {
    const imgLeft = (CROP-dispW)/2 + offset.x;
    const imgTop  = (CROP-dispH)/2 + offset.y;
    const srcX = -imgLeft / (fitScale*zoom);
    const srcY = -imgTop  / (fitScale*zoom);
    const srcW = CROP / (fitScale*zoom);
    const srcH = CROP / (fitScale*zoom);
    const canvas = document.createElement('canvas');
    canvas.width = 400; canvas.height = 400;
    canvas.getContext('2d').drawImage(rawImage, srcX, srcY, srcW, srcH, 0, 0, 400, 400);
    canvas.toBlob(blob => {
      setAvatarBlob(blob);
      setAvatarPreview(URL.createObjectURL(blob));
      URL.revokeObjectURL(rawUrl);
      setRawImage(null); setRawUrl(null);
    }, 'image/jpeg', 0.82);
  };

  const cancelCrop = () => {
    URL.revokeObjectURL(rawUrl);
    setRawImage(null); setRawUrl(null);
    setZoom(1); setOffset({x:0,y:0});
  };

  return (
    <Modal onClose={onClose}>
        <div className="modal-title">{title}</div>
        {error&&<div className="alert alert-error">{error}</div>}

        {/* Foto profilo */}
        <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginBottom:20}}>
          {rawImage ? (
            <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:12}}>
              {/* Crop circle */}
              <div
                style={{width:CROP,height:CROP,borderRadius:'50%',overflow:'hidden',
                  position:'relative',cursor:'grab',touchAction:'none',userSelect:'none',
                  background:'var(--surface2)',flexShrink:0}}
                onPointerDown={onPointerDown}
                onPointerMove={onPointerMove}
                onPointerUp={onPointerUp}
                onPointerCancel={onPointerUp}
              >
                <img src={rawUrl} alt="" draggable={false} style={{
                  position:'absolute', pointerEvents:'none',
                  width:dispW, height:dispH,
                  left:(CROP-dispW)/2+offset.x,
                  top:(CROP-dispH)/2+offset.y,
                }}/>
              </div>
              {/* Zoom */}
              <div style={{display:'flex',alignItems:'center',gap:10,width:CROP}}>
                <span style={{fontSize:16,color:'var(--muted)',flexShrink:0}}>A</span>
                <input type="range" min="1" max="3" step="0.01" value={zoom}
                  onChange={e=>onZoom(e.target.value)}
                  style={{flex:1,accentColor:'var(--brand)'}}/>
                <span style={{fontSize:20,color:'var(--muted)',flexShrink:0}}>A</span>
              </div>
              {/* Azioni */}
              <div style={{display:'flex',gap:8}}>
                <button className="btn btn-secondary btn-sm" onClick={cancelCrop}>Annulla</button>
                <button className="btn btn-primary btn-sm" onClick={confirmCrop}>Conferma</button>
              </div>
            </div>
          ) : (
            <>
              <div onClick={()=>fileRef.current.click()} style={{cursor:'pointer',position:'relative'}}>
                {avatarPreview
                  ? <img src={avatarPreview} alt="" style={{width:72,height:72,borderRadius:'50%',objectFit:'cover',display:'block'}}/>
                  : <div className="avatar" style={{width:72,height:72,fontSize:26}}>{firstName.charAt(0)||'?'}</div>
                }
                <div style={{position:'absolute',bottom:0,right:0,width:22,height:22,borderRadius:'50%',
                  background:'var(--brand)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                  </svg>
                </div>
              </div>
              <span style={{fontSize:16,color:'var(--muted)',marginTop:6}}>Tocca per cambiare foto</span>
            </>
          )}
          <input ref={fileRef} type="file" accept="image/*" style={{display:'none'}} onChange={handleFileChange}/>
        </div>

        <div className="form-group"><label className="form-label">Nome e Cognome</label>
          <div style={{display:'flex',gap:10}}>
            <input className="form-input" placeholder="Nome" value={firstName} onChange={e=>setFirstName(e.target.value)}/>
            <input className="form-input" placeholder="Cognome" value={lastName} onChange={e=>setLastName(e.target.value)}/>
          </div>
        </div>
        <div className="form-group"><label className="form-label">Email</label><input className="form-input" type="email" value={email} onChange={e=>setEmail(e.target.value)}/></div>
        <div className="form-group"><label className="form-label">Città</label><input className="form-input" placeholder="es. Roma" value={city} onChange={e=>setCity(e.target.value)}/></div>
        <div style={{height:1,background:"var(--border)",margin:"16px 0"}}/>
        <div className="form-row">
          <div className="form-group"><label className="form-label">Telefono</label><input className="form-input" placeholder="+39 333..." value={phone} onChange={e=>setPhone(e.target.value)}/></div>
          <div className="form-group"><label className="form-label">Link WhatsApp</label><input className="form-input" placeholder="https://wa.me/39..." value={whatsapp} onChange={e=>setWhatsapp(e.target.value)}/></div>
        </div>
        <div style={{fontSize:18,fontWeight:700,color:"var(--text)",marginBottom:12}}>Cosa suoni</div>
        <div className="form-group"><label className="form-label">Strumenti</label>
          <div className="chip-group">{INSTRUMENTS.map(i=><span key={i} className={`chip ${instruments.includes(i)?"selected":""}`} onClick={()=>toggle(instruments,setInstruments,i)}>{i}</span>)}</div></div>
        <div className="form-group"><label className="checkbox-row"><input type="checkbox" checked={sings} onChange={e=>{setSings(e.target.checked);if(!e.target.checked)setDefaultSings(false);}}/> Canto / Voce</label></div>
        {(instruments.length>0||sings)&&<div className="form-group">
          <label className="form-label">Strumento / ruolo principale</label>
          <div style={{fontSize:16,color:'var(--muted)',marginBottom:8}}>Usato per aderire automaticamente ai brani</div>
          <div className="chip-group">
            {sings&&<span className={`chip ${defaultSings&&!defaultInstrument?'selected':''}`}
              onClick={()=>{setDefaultSings(true);setDefaultInstrument('');}}>Voce</span>}
            {instruments.map(i=><span key={i} className={`chip ${defaultInstrument===i&&!defaultSings?'selected':''}`}
              onClick={()=>{setDefaultInstrument(i);setDefaultSings(false);}}>{i}</span>)}
            {sings&&instruments.map(i=><span key={'v+'+i} className={`chip ${defaultInstrument===i&&defaultSings?'selected':''}`}
              onClick={()=>{setDefaultInstrument(i);setDefaultSings(true);}}>Voce + {i}</span>)}
          </div>
        </div>}
        {allRoles.length>0&&<div className="form-group"><label className="form-label">Livello</label>
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {allRoles.map(r=>(
              <div key={r} style={{display:"flex",alignItems:"center",gap:12}}>
                <span style={{fontSize:17,fontWeight:700,minWidth:100,color:"var(--text)"}}>{r}</span>
                <select className="form-select" style={{flex:1}}
                  value={levels[r]||0} onChange={e=>setLevel(r,parseInt(e.target.value))}>
                  {LEVEL_LABELS.map((l,i)=><option key={i} value={i}>{i===0?"Non indicato":l}</option>)}
                </select>
              </div>
            ))}
          </div>
        </div>}
        <div style={{height:1,background:"var(--border)",margin:"16px 0"}}/>
        <div style={{fontSize:18,fontWeight:700,color:"var(--text)",marginBottom:12}}>Generi musicali</div>
        <div className="form-group"><label className="form-label">Cosa ti piace</label>
          <div className="chip-group">{GENRES.map(g=><span key={g} className={`chip ${genres.includes(g)?"selected":""}`} onClick={()=>toggle(genres,setGenres,g)}>{g}</span>)}</div></div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Annulla</button>
          <button className="btn btn-primary" disabled={!firstName.trim()||!lastName.trim()||!email.trim()||loading}
            onClick={async()=>{
              setError(""); setLoading(true);
              try {
                let extra={};
                if(avatarBlob){
                  const url=await uploadAvatarImage(musician.id,avatarBlob);
                  extra.avatar_url=url;
                }
                await onSave({first_name:firstName.trim(),last_name:lastName.trim(),email:email.trim().toLowerCase(),city,instruments,sings,genres,levels,phone,whatsapp_link:whatsapp,default_instrument:defaultInstrument||null,default_sings:defaultSings,...extra});
              } catch { setError("Errore."); } finally { setLoading(false); }
            }}>
            {loading?<span className="spinner"/>:"Salva"}</button>
        </div>
    </Modal>
  );
}

export default ProfileEditModal;
